import axios from 'axios';

export async function consultaRuc(ruc) {
  // Consulta al backend local
  const url = `/api/consulta-peru/ruc/${ruc}`;
  try {
    const { data } = await axios.get(url);
    return data;
  } catch (error) {
    return null;
  }
}

export async function consultaDni(dni) {
  // Consulta al backend local
  const url = `/api/consulta-peru/dni/${dni}`;
  try {
    const { data } = await axios.get(url);
    return data;
  } catch (error) {
    return null;
  }
}
